import { ManageAccessService } from 'services';
import { typeMap } from './typeMap';

/**
 * Fetch data based on the offset and limit.
 *
 * @param {number} offset - Offset value.
 * @param {number} limit - Limit value.
 * @returns {Promise<void>} A promise that resolves when the data is fetched.
 */
export const fetchMemberList = async (
    offset: number,
    limit: number
): Promise<{
    paginatedResult: MembersList[];
    totalCount: { count: number }[];
}> =>
    new Promise((resolve, reject) => {
        ManageAccessService.getMembers({ offset, limit })
            .then(
                (response: {
                    data: {
                        msg: string;
                        data: {
                            paginatedResult: MembersList[];
                            totalCount: { count: number }[];
                        }[];
                    };
                }) => {
                    if (
                        response.data.data.length > 0 &&
                        response.data.data.some(
                            (o) =>
                                o.totalCount.some((i) => i.count > 0) === true
                        )
                    ) {
                        resolve({
                            paginatedResult: Array.from(
                                response.data.data[0].paginatedResult
                            ).map((data) => ({
                                ...data,

                                role: typeMap[data.role]?.[0],
                            })),
                            totalCount: response.data.data[0].totalCount,
                        });
                    } else {
                        reject(response.data.msg);
                    }
                }
            )
            .catch(reject);
    });
